<template>
<svg xmlns="http://www.w3.org/2000/svg" class="tw-fill-[#606060] dark:tw-fill-white" viewBox="0 0 24 24"><path d="M14 24a1 1 0 0 1-.6-.2l-4-3A1 1 0 0 1 9 20v-5.62l-7.02-7.9A3.9 3.9 0 0 1 4.9 0h14.2a3.9 3.9 0 0 1 2.91 6.49L15 14.38V23a1 1 0 0 1-1 1m-3-4.5 2 1.5v-7a1 1 0 0 1 .25-.66l7.27-8.18A1.9 1.9 0 0 0 19.1 2H4.9a1.9 1.9 0 0 0-1.42 3.16l7.27 8.18A1 1 0 0 1 11 14z"/></svg>
</template>
